import { normalizeOrganizedTourSearchResult } from "./normalizeOrganizedTourSearchResult";
import { resolveOrganizedTourDestinationImage } from "./resolveOrganizedTourDestinationImage";
import { resolveOrganizedTourDisplayOrderRef } from "./resolveOrganizedTourDisplayOrderRef";
import { resolveOrganizedTourSearchDisplayNumber } from "./resolveOrganizedTourSearchDisplayNumber";
import { upgradeOrganizedTourRemoteImageUrl } from "./organizedTourHeroImageSsot";
import { resolveOrganizedTourProfileDisplayIls } from "../modules/organizedTours/utils/resolveOrganizedTourSearchCardPackageIls";

function formatProfileDate(raw) {
  const s = String(raw ?? "").trim();
  if (!s) return "—";
  const parts = s.split(/[/-]/);
  if (parts.length === 3 && parts[0].length === 4) {
    return `${parts[2]}/${parts[1]}/${parts[0]}`;
  }
  const space = s.split(/\s+/)[0];
  if (space.includes("/")) return space;
  return s;
}

/**
 * @param {object} params
 * @param {unknown} params.selectedResult
 * @param {string|null} params.resourceUrl
 * @param {object|null} params.ourPrice
 * @param {object|null} params.savedOrder
 */
export function buildOrganizedTourProfileViewModel({
  selectedResult,
  resourceUrl,
  ourPrice,
  savedOrder,
  calculateLDSDealFareForRoomsComposition,
}) {
  const normalized = normalizeOrganizedTourSearchResult(selectedResult);
  const dest = resolveOrganizedTourDestinationImage(selectedResult, {
    tourName: normalized.tourName,
    routeLabel: normalized.routeLabel,
    routeCities: normalized.routeCities,
  });
  const heroImageRaw =
    (resourceUrl && String(resourceUrl).trim()) ||
    normalized.imageUrl ||
    dest.resolvedImage ||
    "";
  const heroImage = heroImageRaw
    ? upgradeOrganizedTourRemoteImageUrl(String(heroImageRaw).trim())
    : "";
  const imageSource = resourceUrl
    ? "getOrgTourInfo.resourceUrl"
    : normalized.imageSource || dest.imageSource;

  const hrRef = savedOrder
    ? resolveOrganizedTourDisplayOrderRef(savedOrder, { log: false })
    : null;
  const displayMeta = hrRef?.display
    ? {
        show: true,
        value: hrRef.display,
        source: hrRef.source || "resolveOrganizedTourDisplayOrderRef",
      }
    : resolveOrganizedTourSearchDisplayNumber(selectedResult);

  // Package ILS only (no payment CC) — match search cards / sticky SSOT.
  const priceIls = resolveOrganizedTourProfileDisplayIls({
    ourPrice,
    selectedResult,
    calculateLDSDealFareForRoomsComposition,
  });

  return {
    ...normalized,
    heroImage,
    imageSource,
    heroImageFallbackUsed: !heroImage,
    displayOfferNumber: displayMeta.show ? displayMeta.value : "",
    displayOfferSource: displayMeta.source,
    depDateLabel: formatProfileDate(normalized.depDate),
    retDateLabel: formatProfileDate(normalized.retDate),
    priceIls: priceIls != null && Number.isFinite(Number(priceIls)) ? Number(priceIls) : null,
    supplierLabel: normalized.supplierId || "",
  };
}
